import makeStyles from "@mui/styles/makeStyles";

export default makeStyles(
  (theme) => ({
    paper: {
      overflowY: "initial",
      padding: [15, 13, 13],
      minWidth: 288,
      borderRadius: 10,
      boxShadow: "0 3px 6px 0 rgba(0,0,0,.25)",
      position: "relative",
      [theme.breakpoints.up("mobile")]: {
        width: 459,
        padding: [24, 20, 20],
        borderRadius: 20,
      },
    },
    dialogContent: {
      paddong: 0,
    },
    actions: {
      width: 180,
      margin: [0, "auto"],
      paddingTop: 12,
    },
  }),
  { name: "MakeMessageModal" },
);
